import { cartCollection } from "@/firebase";
import { storage } from "@/firebase";
import * as c from "@/constants";
import storeImageDiscount from "@/store/storeImageDiscount";
import store from "@/store";

const state = {
  cart: [],
  modPhotoOrderSummary: {
    totalSumLabPrice: 0, // znesek paketov brez popustov
    totalSumQuantityDiscount: 0,
    totalSumQuantityPrice: 0,
    totalSumQuantityDiscountPrice: 0,
    totalSumQuantityNextDiscount: 0,
    totalSumQuantityNextCopies: 0,
    totalSumPhotoOrder: 0, // končna cena modula
    totalCopies: 0, // vseh slik skupaj (vsi paketi)
    totalTempCopies: 0, // za iteracijo po paketih posamezno, št. kopij
    totalTempImageData: [], // za generacijo seznama, ki prikazuje formte in št. slik v paketu
    totalSumImageSizes: [],
    totalSumPromoCodeDiscount: 0,
    totalSumPromoCodeDiscountPrice: 0,
    totalSumExtraCharge: 0,
  },
  modPhotoGiftSummary: {
    totalSumLabPrice: 0,
    totalSumPhotoGift: 0,
    totalCopies: 0, // vseh izdelkov skupaj (vsi paketi)
    totalSumPromoCodeDiscount: 0,
    totalSumPromoCodeDiscountPrice: 0,
    totalSumExtraCharge: 0,
  },
  totalSumCart: 0, // končna cena vseh modulov
  totalSumPromoCodeDiscount: 0,
  totalSumPromoCodeDiscountPrice: 0,
  activePromoCode: "",
  activePromoCodeId: "",
  activePromoCodeModule: "",
  activePromoCodePermanent: false,
  activePromoCodeActivated: false,
  activePromoCodeItem: "",
  activePromoCodeItemName: "",
  activePromoCodeSubItem: "",
  activePromoCodeSubItemName: "",
  activePromoCodeSuperCategory: "",
  activePromoCodeSuperCategoryName: "",
  activePromoCodeCategory: "",
  activePromoCodeCategoryName: "",
  activePromoCodeDiscountType: "",
  promoCodeAlreadyActivated: false,
  activePromoCodeDiscount: 0,
};

const getters = {};

const actions = {
  getCartInfo() {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      console.log("==> getCartInfo");

      state.totalSumCart = 0; // glavni znesek naročila brez promo kode
      state.totalSumPromoCodeDiscount = 0;
      state.totalSumPromoCodeDiscountPrice = 0;
      state.activePromoCodeItem = "";
      state.activePromoCodeItemName = "";
      state.activePromoCodeSubItem = "";
      state.activePromoCodeSubItemName = "";
      state.activePromoCodeSuperCategory = "";
      state.activePromoCodeSuperCategoryName = "";
      state.activePromoCodeCategory = "";
      state.activePromoCodeCategoryName = "";
      state.activePromoCodeDiscountType = "";
      state.activePromoCode = "";
      state.activePromoCodeId = "";
      state.activePromoCodeModule = "";
      state.activePromoCodePermanent = false;
      state.activePromoCodeActivated = false;
      state.promoCodeAlreadyActivated = false;
      state.activePromoCodeDiscount = 0;

      state.modPhotoOrderSummary.totalSumLabPrice = 0;
      state.modPhotoOrderSummary.totalSumQuantityDiscount = 0;
      state.modPhotoOrderSummary.totalSumQuantityPrice = 0;
      state.modPhotoOrderSummary.totalSumQuantityDiscountPrice = 0;
      state.modPhotoOrderSummary.totalSumQuantityNextDiscount = 0;
      state.modPhotoOrderSummary.totalSumQuantityNextCopies = 0;
      state.modPhotoOrderSummary.totalSumPhotoOrder = 0;
      state.modPhotoOrderSummary.totalCopies = 0;
      state.modPhotoOrderSummary.totalTempCopies = 0;
      state.modPhotoOrderSummary.totalTempImageData = [];
      state.modPhotoOrderSummary.totalSumImageSizes = [];
      state.modPhotoOrderSummary.totalSumPromoCodeDiscount = 0;
      state.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice = 0;
      state.modPhotoOrderSummary.totalSumExtraCharge = 0;

      state.modPhotoGiftSummary.totalSumLabPrice = 0;
      state.modPhotoGiftSummary.totalSumPhotoGift = 0;
      state.modPhotoGiftSummary.totalCopies = 0;
      state.modPhotoGiftSummary.totalSumPromoCodeDiscount = 0;
      state.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;
      state.modPhotoGiftSummary.totalSumExtraCharge = 0;

      if (
        state.cart.filter((item) => item.module == c.G_MODULE_PHOTO_ORDER).length >
        0
      ) {
        //******************************* */
        /* IZRAČUN ZA MODUL MODPHOTOORDER */
        /******************************** */
        state.modPhotoOrderSummary.totalCopies = 0;
        state.modPhotoOrderSummary.totalTempCopies = 0;
        state.modPhotoOrderSummary.totalSumImageSizes = [];
        state.modPhotoOrderSummary.totalSumImageData = [];
        state.modPhotoOrderSummary.totalSumLabPrice = 0;
        state.modPhotoOrderSummary.totalSumPhotoOrder = 0;
        state.modPhotoOrderSummary.totalSumExtraCharge = 0;
        state.modPhotoOrderSummary.totalSumPromoCodeDiscount = 0;
        state.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice = 0;

        // seštejemo koliko slik ima vsak format
        Array.from(
          state.cart.filter((item) => item.module == c.G_MODULE_PHOTO_ORDER)
        ).forEach((item) => {
          state.modPhotoOrderSummary.totalTempCopies = 0;
          state.modPhotoOrderSummary.totalTempImageData = [];
          //console.log(item.id);
          Array.from(item.itemDetails).forEach((x) => {
            state.modPhotoOrderSummary.totalCopies += parseInt(x.copies);
            state.modPhotoOrderSummary.totalTempCopies += parseInt(x.copies);
            //console.log(x.name);
            Array.from(x.sumPaperTypes.filter((i) => i.copies > 0)).forEach(
              (y) => {
                // izračun cene z vključenim doplačilom za papir
                state.modPhotoOrderSummary.totalSumLabPrice +=
                  parseInt(y.copies) *
                  (parseFloat(x.price) *
                    (parseInt(1) + parseFloat(y.price / 100)));

                state.modPhotoOrderSummary.totalTempImageData.push({
                  str:
                    x.name +
                    " | " +
                    y.paperType +
                    " | " +
                    y.copies +
                    " x " +
                    (y.price > 0
                      ? Intl.NumberFormat(
                        store.state.storeClient.client.environmentSettings
                          .numberFormat,
                        {
                          style: "currency",
                          currency:
                            store.state.storeClient.client.environmentSettings
                              .currency,
                          minimumFractionDigits:
                            store.state.storeClient.client.environmentSettings
                              .digits,
                        }
                      ).format(
                        parseFloat(x.price) *
                        (parseInt(1) + parseFloat(y.price / 100))
                      )
                      : Intl.NumberFormat(
                        store.state.storeClient.client.environmentSettings
                          .numberFormat,
                        {
                          style: "currency",
                          currency:
                            store.state.storeClient.client.environmentSettings
                              .currency,
                          minimumFractionDigits:
                            store.state.storeClient.client.environmentSettings
                              .digits,
                        }
                      ).format(x.price)) +
                    (y.price > 0
                      ? " (+" +
                      Intl.NumberFormat(
                        store.state.storeClient.client.environmentSettings
                          .numberFormat,
                        {
                          style: "percent",
                          minimumFractionDigits: 0,
                        }
                      ).format(y.price / 100) +
                      ")"
                      : ""),
                });
              }
            );

            // naredimo array z izračunanimi povzetki slik in cen
            if (
              state.modPhotoOrderSummary.totalSumImageSizes.filter(
                (item) => item.name == x.name // najprej pogledamo ali smo že računali ta foramt
              ).length > 0
            ) {
              state.modPhotoOrderSummary.totalSumImageSizes.find(
                (item) => item.name == x.name // če ja, potem prištejemo obstoječemu elementu
              ).copies += parseInt(x.copies);
            } else {
              // če ne obstaja, dodamo novega
              let tempObj = {
                name: x.name,
                copies: x.copies,
                price: x.price,
              };
              state.modPhotoOrderSummary.totalSumImageSizes.push(tempObj);
            }
          });
          item.totalCopies = state.modPhotoOrderSummary.totalTempCopies;
          item.imageDataStr = state.modPhotoOrderSummary.totalTempImageData;
        });

        state.modPhotoOrderSummary.totalSumQuantityDiscount = 0;
        state.modPhotoOrderSummary.totalSumQuantityPrice = 0;
        state.modPhotoOrderSummary.totalSumQuantityDiscountPrice = 0;
        state.modPhotoOrderSummary.totalSumQuantityNextDiscount = 0;
        state.modPhotoOrderSummary.totalSumQuantityNextCopies = 0;

        // IMAGE DISCOUNT CALCULATON      
        // najprej sortiramo, ker so urejeni po stringih in ne po integerju
        storeImageDiscount.state.imageDiscount.sort((a, b) =>
          parseInt(a.quantity) > parseInt(b.quantity) ? 1 : -1
        );

        // poiščemo, kam v kateri popust spada št. slik
        let found = false;
        storeImageDiscount.state.imageDiscount.forEach((item) => {
          if (item.quantity <= state.modPhotoOrderSummary.totalCopies) {
            state.modPhotoOrderSummary.totalSumQuantityDiscount = item.price;
          } else {
            if (!found) {
              found = true;
              state.modPhotoOrderSummary.totalSumQuantityNextDiscount =
                item.price;
              state.modPhotoOrderSummary.totalSumQuantityNextCopies =
                item.quantity;
            }
          }
        });

        // cena s količinskim popustom
        state.modPhotoOrderSummary.totalSumQuantityPrice =
          (parseInt(1) -
            parseFloat(
              state.modPhotoOrderSummary.totalSumQuantityDiscount / 100
            )) *
          state.modPhotoOrderSummary.totalSumLabPrice;

        // znesek količinskega popusta
        state.modPhotoOrderSummary.totalSumQuantityDiscountPrice =
          state.modPhotoOrderSummary.totalSumLabPrice -
          state.modPhotoOrderSummary.totalSumQuantityPrice;

        // znesek extraCharge, če je potrebno
        if (
          Number(
            store.state.storeClient.client.modules.modulePhotoOrder.extraCharge
          ) > 0 &&
          (state.modPhotoOrderSummary.totalSumQuantityPrice <
            Number(
              store.state.storeClient.client.modules.modulePhotoOrder
                .extraChargeFreeOver
            ) ||
            Number(
              store.state.storeClient.client.modules.modulePhotoOrder
                .extraChargeFreeOver
            ) == 0)
        ) {
          state.modPhotoOrderSummary.totalSumExtraCharge =
            state.modPhotoOrderSummary.totalSumQuantityPrice +
            Number(
              store.state.storeClient.client.modules.modulePhotoOrder.extraCharge
            );
        } else
          state.modPhotoOrderSummary.totalSumExtraCharge =
            state.modPhotoOrderSummary.totalSumQuantityPrice;

        state.modPhotoOrderSummary.totalSumPhotoOrder =
          state.modPhotoOrderSummary.totalSumExtraCharge;
        state.totalSumCart += state.modPhotoOrderSummary.totalSumPhotoOrder;

        /*console.log(
          "totalSumLabPrice: " + state.modPhotoOrderSummary.totalSumLabPrice
        );
        console.log(
          "totalSumQuantityPrice: " +
            state.modPhotoOrderSummary.totalSumQuantityPrice
        );
        console.log(
          "totalSumQuantityDiscountPrice: " +
            state.modPhotoOrderSummary.totalSumQuantityDiscountPrice
        );
        console.log(
          "totalSumExtraCharge: " + state.modPhotoOrderSummary.totalSumExtraCharge
        );
        console.log(
          "extraCharge: " +
            store.state.storeClient.client.modules.modulePhotoOrder.extraCharge
        );
        console.log(
          "extraChargeFreeOver: " +
            store.state.storeClient.client.modules.modulePhotoOrder
              .extraChargeFreeOver
        );
        console.log(
          "totalSumPhotoOrder: " + state.modPhotoOrderSummary.totalSumPhotoOrder
        );*/
      }
      if (
        state.cart.filter((item) => item.module == c.G_MODULE_PHOTO_GIFT).length > 0
      ) {
        //****************************** */
        /* IZRAČUN ZA MODUL MODPHOTOGIFT */
        /******************************* */
        state.modPhotoGiftSummary.totalCopies = 0;
        state.modPhotoGiftSummary.totalSumLabPrice = 0;
        state.modPhotoGiftSummary.totalSumPhotoGift = 0;
        state.modPhotoGiftSummary.totalSumExtraCharge = 0;
        state.modPhotoGiftSummary.totalSumPromoCodeDiscount = 0;
        state.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;

        // seštejemo koliko izdelkov in katere vrste
        Array.from(
          state.cart.filter((item) => item.module == c.G_MODULE_PHOTO_GIFT)
        ).forEach((item) => {

          item.imageDataStr =
            (item.itemType.length > 0 ? item.itemType + " | " : "") +
            item.itemCopies +
            " x " +
            Intl.NumberFormat(
              store.state.storeClient.client.environmentSettings.numberFormat,
              {
                style: "currency",
                currency:
                  store.state.storeClient.client.environmentSettings.currency,
                minimumFractionDigits:
                  store.state.storeClient.client.environmentSettings.digits,
              }
            ).format(item.itemPrice);

          state.modPhotoGiftSummary.totalCopies += Number(item.itemCopies);
          state.modPhotoGiftSummary.totalSumLabPrice +=
            Number(item.itemCopies) * parseFloat(item.itemPrice);
        });

        // znesek extraCharge, če je potrebno
        if (
          Number(
            store.state.storeClient.client.modules.modulePhotoGift.extraCharge
          ) > 0 &&
          (state.modPhotoGiftSummary.totalSumLabPrice <
            Number(
              store.state.storeClient.client.modules.modulePhotoGift
                .extraChargeFreeOver
            ) ||
            Number(
              store.state.storeClient.client.modules.modulePhotoGift
                .extraChargeFreeOver
            ) == 0)
        ) {
          state.modPhotoGiftSummary.totalSumExtraCharge =
            state.modPhotoGiftSummary.totalSumLabPrice +
            Number(
              store.state.storeClient.client.modules.modulePhotoGift.extraCharge
            );
        } else
          state.modPhotoGiftSummary.totalSumExtraCharge =
            state.modPhotoGiftSummary.totalSumLabPrice;

        state.modPhotoGiftSummary.totalSumPhotoGift =
          state.modPhotoGiftSummary.totalSumExtraCharge;
        state.totalSumCart += state.modPhotoGiftSummary.totalSumPhotoGift;

        /*console.log(
          "totalSumPromoCodeDiscountPrice: " + state.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice
        );

        console.log("=====");
        console.log(
          "totalSumLabPrice: " + state.modPhotoGiftSummary.totalSumLabPrice
        );
        console.log(
          "totalSumExtraCharge: " + state.modPhotoGiftSummary.totalSumExtraCharge
        );
        console.log(
          "extraCharge: " +
            store.state.storeClient.client.modules.modulePhotoGift.extraCharge
        );
        console.log(
          "extraChargeFreeOver: " +
            store.state.storeClient.client.modules.modulePhotoGift
              .extraChargeFreeOver
        );
        console.log(
          "totalSumPhotoGift: " + state.modPhotoGiftSummary.totalSumPhotoGift
        );*/
      }

      resolve("OK");
      //console.log("getCartInfo", state.cart)
    });
  },

  getCartItems({ commit }, payload) {
    // real-time listener
    cartCollection
      .where("client", "==", payload.client)
      .where("uid", "==", payload.uid)
      .where("status", "==", payload.status)
      .orderBy("module", "asc")
      .orderBy("timestamp", "asc")
      .onSnapshot((snapshot) => {
        let tempData = [];
        let action = "";
        let changeId = "";
        snapshot.docChanges().forEach(
          (change) => {
            if (change.type == "added") {
              tempData.push(
                // enakovredna stavka, en bolj fensi ...change - spread operator
                //Object.assign(change.doc.data(), { id: change.doc.id })
                {
                  ...change.doc.data({ serverTimestamps: "estimate" }), // serverTimestamps opcija da določi približni timestamp, dokler pravi ne pride s serverja
                  id: change.doc.id,
                }
              );
              action = "added";
              console.log("CART: added");
            } else if (change.type === "modified") {
              action = "modified";
              console.log("CART: modified");
            } else if (change.type == "removed") {
              changeId = change.doc.id;
              action = "removed";
              console.log("CART: removed");
            }
          },
          (error) => {
            console.log(error);
          }
        );
        if (action == "added") {
          commit("getCartItems", tempData);
          this.dispatch("getCartInfo");
        } else if (action == "modified") {
          //commit("changeCartState", payload);
        } else if (action == "removed") {
          commit("removeFromCart", changeId);
          this.dispatch("getCartInfo");
        }
      });
  },

  // eslint-disable-next-line
  removeFromCart({ commit }, payload) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      cartCollection
        .doc(payload.id)
        .delete()
        .then(() => {
          const storageRef = storage
            .ref()
            .child(c.G_STORAGE_DEFAULT_DIR + "/" + payload.cartId);
          storageRef.delete().catch(function (error) {
            alert(error);
          });
          resolve("OK");
        });
    });
  },

  // eslint-disable-next-line
  addToCart({ commit }, payload) {
    // namesto .add je treba razbiti v referenco in potem .set, da lahko vrinemo server timestamp
    let cartRef = cartCollection.doc();
    cartRef.set(payload).catch((error) => {
      console.log(error);
    });
  },

  // eslint-disable-next-line
  changeCartState({ commit }, payload) {
    cartCollection
      .doc(payload.id)
      .update(payload)
      .catch((error) => {
        console.log(error);
      });
  },
};

const mutations = {
  getCartItems(state, payload) {
    payload.forEach((item) => {
      state.cart.push(item);
    });
    console.log("getCartItems", state.cart);
  },
  removeFromCart(state, payload) {
    const index = state.cart.findIndex((item) => item.id == payload);
    state.cart.splice(index, 1);
    console.log("removeFromCart", state.cart);
  },
  /*changeCartState(state, payload) {
    const index = state.cart.findIndex((item) => item.id == payload.id);
    state.cart.splice(index, 1, payload);
    console.log(state.cart);
  },*/
};

export default {
  state,
  getters,
  actions,
  mutations,
};
